import {
  SET_TITLE,
  SET_ONCONFIRM
} from './types';

const actions = {
  setTitleModal({ commit }, title) {
    commit(SET_TITLE, title);
  },

  setOnConfirm({ commit }, onConfirm) {
    commit(SET_ONCONFIRM, onConfirm);
  }
};

export default actions;
